import { createContext } from "react";

export const AnnouncementsContext = createContext();
